import { render } from "./SortimentNavigation.vue?vue&type=template&id=6baef40d&scoped=true"
import script from "./SortimentNavigation.vue?vue&type=script&lang=js"
export * from "./SortimentNavigation.vue?vue&type=script&lang=js"

import "./SortimentNavigation.vue?vue&type=style&index=0&id=6baef40d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6baef40d"]])

export default __exports__